import { LOG_OUT } from "../../../auth/actions/actions-types";
import { ActionTypes, type ActionReturns } from "./activeLearningPath.actions";
import { initialState, type State } from "./activeLearningPath.state";

export const defaultReducer = (
  state: State = initialState,
  action: ActionReturns
): State => {
  switch (action.type) {
    case ActionTypes.SET_ACTIVE_LEARNING_PATH: {
      return action.payload.learningPathId;
    }
    case LOG_OUT: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
